export default __webpack_public_path__ + "images/c8e7c990fb937fc6aafca3e3077bcfdc.svg";